import {
  objectsRef,
  objectsCreate,
  objectsGet,
  objectsUpdate,
  objectsDelete,
  objectsFilterSave,
  objectsFilterGet,
  objectsInfo
} from "@/api/objects.api";

import {
  OBJECTS_LIST_READ,
  OBJECTS_READ,
  OBJECTS_COPY_READ,
  OBJECTS_CREATE,
  OBJECTS_UPDATE,
  OBJECTS_DELETE,
  OBJECTS_LIST_CLEAR,
  OBJECTS_CLEAR,
  OBJECTS_COPY_CLEAR,
  OBJECTS_FILTER_GET,
  OBJECTS_FILTER_SAVE,
  OBJECTS_NAVIGATION_SET,
  OBJECTS_NAVIGATION_SELECT,
  OBJECTS_INFO,
  OBJECTS_ANY_PARAMS_CLEAR
} from "../type";

const state = {
  objectsList: [],
  objectsListNavigation: [],
  object: undefined,
  objectCopy: undefined,
  filter: undefined,
  info: []
};

const getters = {};

const actions = {
  async [OBJECTS_LIST_READ]({ commit }, lang) {
    try {
      const response = await objectsRef(lang);
      commit(OBJECTS_LIST_READ, response.data.objects);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [OBJECTS_READ]({ commit }, { id, lang }) {
    try {
      const response = await objectsGet(id, lang);
      commit(OBJECTS_READ, response.data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [OBJECTS_COPY_READ]({ commit }, { id, lang }) {
    try {
      const response = await objectsGet(id, lang);
      commit(OBJECTS_COPY_READ, response.data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [OBJECTS_CREATE](undefined, { lang, data }) {
    try {
      const response = await objectsCreate(lang, data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [OBJECTS_UPDATE](undefined, { id, lang, data }) {
    try {
      const response = await objectsUpdate(id, lang, data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [OBJECTS_DELETE](undefined, id) {
    try {
      const response = await objectsDelete(id);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [OBJECTS_INFO]({ commit }, { lang, data }) {
    try {
      const response = await objectsInfo(lang, data);
      commit(OBJECTS_INFO, response.data.info);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  }
};

const mutations = {
  [OBJECTS_ANY_PARAMS_CLEAR](state) {
    state.objectsListNavigation = [];
    state.filter = undefined;
    state.info = [];
  },
  [OBJECTS_LIST_READ](state, list) {
    state.objectsList = list;
  },
  [OBJECTS_READ](state, obj) {
    state.object = obj;
  },
  [OBJECTS_COPY_READ](state, obj) {
    state.objectCopy = obj;
  },
  [OBJECTS_LIST_CLEAR](state) {
    state.objectsList = [];
  },
  [OBJECTS_CLEAR](state) {
    state.object = undefined;
  },
  [OBJECTS_COPY_CLEAR](state) {
    state.objectCopy = undefined;
  },
  [OBJECTS_FILTER_GET](state) {
    state.filter = objectsFilterGet();
  },
  [OBJECTS_FILTER_SAVE](state, val) {
    state.filter = objectsFilterSave(val);
  },
  [OBJECTS_NAVIGATION_SET](state, list) {
    state.objectsListNavigation = list;
  },
  [OBJECTS_NAVIGATION_SELECT](state, list) {
    let len = state.objectsListNavigation.length;

    list.forEach(item => {
      if (item.index < len) {
        state.objectsListNavigation[item.index].selected = item.value;
      }
    });
  },
  [OBJECTS_INFO](state, info) {
    state.info = info;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
